// extracted by mini-css-extract-plugin
export default {"container":"MainLayout_container__YzzQu","main":"MainLayout_main__i-uQO","mainCollapsed":"MainLayout_mainCollapsed__0Fph7","main__content":"MainLayout_main__content__cj1sA"};